// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"50":"e8348ddc","545":"026c7697"}[chunkId] + ".chunk.js";
};